(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/account-selector-react/assets/react/account-selector.js') >= 0) return;  svs.modules.push('/components/numbergames/account-selector-react/assets/react/account-selector.js');

'use strict';

const {
  useEffect,
  useCallback,
  useReducer
} = React;
const {
  accountSelector
} = svs.numbergames;
const {
  events: {
    FETCHED,
    ACTIVE_ACCOUNT_CHANGED,
    ACCOUNT_BALANCE_UPDATED
  }
} = svs.numbergames.accountSelector.constants;
const {
  reducer,
  initialState,
  actions: {
    setAccountList,
    fetchAccountList,
    setAccount,
    initialize
  }
} = svs.numbergames.accountSelectorReact;
const {
  Select,
  Option
} = svs.ui.reactForm;
const {
  Currency: formatCurrency
} = svs.utils.format;
const AccountSelector = _ref => {
  let {
    onChange
  } = _ref;
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    const listener = async () => typeof onChange === 'function' && onChange(await accountSelector.getActiveAccount());
    const events = {
      [ACTIVE_ACCOUNT_CHANGED]: listener
    };
    accountSelector.on(events);
    return () => accountSelector.off(events);
  }, [onChange]);
  useEffect(() => {
    const fetchedListener = _ref2 => {
      let {
        accounts,
        selectedAccount,
        selectedAccountChanged
      } = _ref2;
      return dispatch(initialize(accounts, selectedAccount, selectedAccountChanged));
    };
    const balanceUpdatedListener = _ref3 => {
      let {
        accounts
      } = _ref3;
      return dispatch(setAccountList(accounts));
    };
    const events = {
      [FETCHED]: fetchedListener,
      [ACCOUNT_BALANCE_UPDATED]: balanceUpdatedListener
    };
    accountSelector.on(events);
    dispatch(fetchAccountList());
    return () => accountSelector.off(events);
  }, []);
  const handleAccountChange = useCallback(async _ref4 => {
    let {
      target: {
        value
      }
    } = _ref4;
    dispatch(setAccount(value));
    typeof onChange === 'function' && onChange(await accountSelector.getActiveAccount());
  }, [onChange, dispatch]);
  if (!state.accountList || state.accountList.length === 1) {
    return React.createElement("div", {
      className: "u-invisible"
    }, React.createElement(Select, {
      v2: true
    }));
  }
  return React.createElement(Select, {
    onChange: handleAccountChange,
    v2: true,
    value: state.selectedAccount
  }, state.accountList.map(_ref5 => {
    let {
      id,
      name,
      balance
    } = _ref5;
    return React.createElement(Option, {
      value: id,
      key: id
    }, "".concat(name, " (").concat(formatCurrency(balance), " kr)"));
  }));
};
svs.numbergames.accountSelectorReact.AccountSelector = AccountSelector;

 })(window);